import React from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx } from "react/jsx-runtime";
import { createLink } from "@tanstack/react-router";
//#region src/Link/index.tsx
const linkClassName = (visited, className) => cn("text-system-info-50 w-fit cursor-pointer underline decoration-transparent duration-200", "hover:decoration-system-info-50", "focus-within:outline-system-info-50", "active:text-type-common active:!decoration-type-common", visited && "visited:text-additional-violet-50 visited:hover:decoration-additional-violet-50", className);
const UiLinkAnchor = React.forwardRef(({ className, visited = true, children, target = "_self", ...rest }, ref) => /* @__PURE__ */ jsx("a", {
	ref,
	target,
	className: linkClassName(visited, className),
	...rest,
	children
}));
UiLinkAnchor.displayName = "UiLinkAnchor";
const RouterLink = createLink(UiLinkAnchor);
const GenericRouterLink = React.forwardRef((props, ref) => {
	const { to, ...rest } = props;
	return /* @__PURE__ */ jsx(RouterLink, {
		ref,
		to: to ?? "/",
		...rest
	});
});
GenericRouterLink.displayName = "GenericRouterLink";
/**
* Дизайн - https://www.figma.com/file/lixEouzSvWhAf04wpHXkIo/%D0%A0%D0%96%D0%94.-UI-Kit?type=design&node-id=7129%3A18277&mode=design&t=vWUhioyR1eyq29FH-1
*/
const Link = React.forwardRef(({ disabled, className, children, visited = true, target = "_self", ...rest }, ref) => {
	if (disabled) {
		const content = typeof children === "function" ? children({
			isActive: false,
			isTransitioning: false
		}) : children;
		return /* @__PURE__ */ jsx("p", {
			className: cn("text-type-light", className),
			ref,
			children: content
		});
	}
	return /* @__PURE__ */ jsx(GenericRouterLink, {
		ref,
		className,
		visited,
		target,
		...rest,
		children
	});
});
Link.displayName = "Link";
//#endregion
export { Link };

//# sourceMappingURL=index.js.map